import React, { useState, useEffect, useRef } from "react";
import {  useDispatch } from "react-redux";
import MessageAlert from "../sharedComponents/messageAlert";
import copyImageBackground from "../../assets/images/cop.png";
import { useTranslation } from "react-i18next";
import {
  createProductItem,
  GalbElHabeb,
} from "../../redux/reducer/productReducer";
import GalbElHabebPopup from "./GalbElHabebPopup";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CopyLink = () => {
  const [quantity, setQuantity] = useState(1);
  const [productLink, setProductLink] = useState("");
  const [additionalInformation, setAdditionalInformation] = useState("");
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null); 
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (message) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 1000);

      // Clear the timeout if the component unmounts
      return () => clearTimeout(timer);
    }
  }, [message]);
  // Handle quantity increment and decrement
  const handleQuantityChange = (type) => {
    setQuantity((prev) =>
      type === "increment" ? prev + 1 : Math.max(1, prev - 1)
    );
  };

  const handleAddToCart = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
    if (productLink.trim()) {
      const data = {
        link: productLink,
        count: quantity,
        additionalInfo: additionalInformation,
      };

      dispatch(createProductItem(data))
        .unwrap()
        .then(() => {
          setMessageType("success");
          setMessage(t("productAddedSuccessfully"));
          setProductLink(""); // Clear input field
          setQuantity(1); // Reset quantity
        })
        .catch((error) => {
          setMessageType("error");
          setMessage(`${t("productAddedFaild")} ${error.message}`);
        });
    } else {
      setMessageType("error");
      setMessage("يرجى إدخال رابط صالح للمنتج.");
    }
  };

  const direction = useLanguageDirection();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handelPopupGalpElhabeb = () => {
    setIsOpen(false);
  };

  // Handle form submission to create a cart item
  const handleGalbElHabeb = async () => {
    setIsOpen(false);

    if (!productLink.trim()) {
      setMessageType("error");
      setMessage(t("enterProductLink"));
      return;
    }

    setIsDisabled(true);
    setIsLoading(true);

    const data = {
      link: productLink,
      count: 1,
    };

    try {
      const res = await dispatch(GalbElHabeb(data)).unwrap();
      setResult(res);
      setIsOpen(true);
    } catch (error) {
      console.error("Error:", error);
      setMessageType("error");
      setMessage(t("somethingWentWrong")); 
    } finally {
      setIsDisabled(false);
      setIsLoading(false);
      setProductLink("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isLoading && !isDisabled) {
      e.preventDefault();
      handleGalbElHabeb();
    }
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!isLoading && !isDisabled) {
      handleGalbElHabeb();
    }
  };
  return (
    <div
      className="relative flex items-center justify-center w-full bg-center bg-cover "
      dir={direction}
    >
      <img
        src={copyImageBackground}
        alt="Your Image Description"
        className="w-full h-full object-cover min-h-[225px] lg:min-h-[20vh] lg:max-h-[275px] "
      />
      <div className="absolute w-full px-5 my-4 space-y-4 lg:w-1/2 md:w-3/5 max-container">
        {/* Display MessageAlert */}
        {showAlert && <MessageAlert type={messageType} message={message} />}
        <p className="font-medium text-center text-white md:text-xl">
          {t("AddProductsCart")}
        </p>
        <form onSubmit={handleFormSubmit}>
          <input
            type="text"
            placeholder={t("LinkProduct")}
            className="w-full p-2 text-gray-700 bg-white border shadow-sm md:p-3 focus:ring focus:ring-yellow-400 focus:outline-none placeholder:text-sm md:placeholder:text-base"
            value={productLink}
            onChange={(e) => setProductLink(e.target.value)}
          />

          <div className="flex items-center justify-end mt-4">
            {isLoading ? (
              // Loading spinner
              <div className="flex items-center justify-center w-full">
                <div className="w-12 h-12 animate-spin">
                  <svg className="w-full h-full" viewBox="0 0 50 50">
                    <circle
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke="#facc15"
                      strokeWidth="5"
                      strokeLinecap="round"
                      strokeDasharray="120"
                      strokeDashoffset="30"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <button
                ref={buttonRef}
                type="submit"
                disabled={isDisabled}
                className={`z-0 inline-flex items-center justify-center px-4 py-2 md:text-base text-sm text-black transition duration-300 ease-in-out transform rounded-custom focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap
          ${
            isDisabled
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-custom-yellow hover:scale-105 hover:bg-custom-yellow"
          }`}
              >
                {t("Shopnow")}
              </button>
            )}
          </div>
        </form>
      </div>
      {isOpen && (
        <div>
          <GalbElHabebPopup
            onClose={handelPopupGalpElhabeb}
            ref={dropdownRef}
            result={result}
            func={true}
          />
        </div>
      )}
    </div>
  );
};

export default CopyLink;
